import { CloseOutlined } from '@mui/icons-material'
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Icon,
    Typography,
} from '@mui/material'
import { ReactElement, useState } from 'react'
import { useAppSelector } from '../../../redux/hook'
import { EntityStepTypes } from '../../../constants/constants'
import StartStep from './StartStep'
import FirstLevelSteps from './FirstLevelSteps'
import Path from './Path'
import Steps from './Steps'
import StepButtons from './StepButtons'
import AttributeStep from './AttributesStep'
import RelationStep from './RelationStep'
import { useTranslation } from 'react-i18next'
import PaperComponent from '../../Common/PaperComponent'

interface InstanceProps {
    handleCloseFields: (a: boolean) => void
    handleAddInParentRelation?: (id: string) => void
}

const Instance = (props: InstanceProps): ReactElement => {
    const { t } = useTranslation()
    const { handleCloseFields, handleAddInParentRelation } = props

    const startStep = useAppSelector((state) => state.entityInstance.startStep)

    const entitySteps = useAppSelector(
        (state) => state.entityInstance.entitySteps,
    )

    const activeStep = useAppSelector(
        (state) => state.entityInstance.activeEntityStep,
    )

    const [isMapOpen, setIsMapOpen] = useState<boolean>(false)

    const onClickMap = (val: boolean) => {
        setIsMapOpen(val)
    }

    return (
        <Dialog
            open={true}
            scroll="paper"
            PaperProps={{
                sx: {
                    maxWidth: '100%',
                    display: isMapOpen ? 'none' : 'block',
                },
            }}
            PaperComponent={PaperComponent}
            aria-labelledby="entity-instance-dialog-title"
            aria-describedby="entity-instance-dialog-description"
            sx={{ padding: '10px 30px' }}
        >
            <Box
                sx={{
                    padding: '10px 30px',
                    width: {
                        md: '60vw',
                        lg: '55vw',
                        xl: '50vw',
                    },
                }}
            >
                <DialogTitle sx={{ padding: '0px' }}>
                    <Box
                        sx={{
                            position: 'absolute',
                            right: '10px',
                            top: '15px',
                            cursor: 'pointer',
                        }}
                    >
                        <Icon
                            onClick={() => handleCloseFields(true)}
                            sx={{ marginRight: '8px' }}
                            fontSize="small"
                            id="entity-form-close-button"
                            aria-label={t('close')}
                            title={t('close')}
                        >
                            <CloseOutlined
                                sx={{
                                    color: '#000',
                                    marginTop: '-2px',
                                }}
                            />
                        </Icon>
                    </Box>
                    {/* Template Name */}
                    <Box
                        sx={{
                            marginTop: '10px',
                            marginBottom: '20px',
                            cursor: 'move',
                        }}
                        id="draggable-dialog-title"
                    >
                        {/* {path?.length == 1 && ( */}
                        <Typography fontSize="16px" fontWeight="600">
                            {t(startStep?.parentTemplateName)}
                        </Typography>
                        {/* )} */}
                    </Box>
                    {/* first level steps */}
                    <FirstLevelSteps />
                    {/* path */}
                    <Path />
                    {/* steps */}
                    <Steps />
                </DialogTitle>
                <DialogContent
                    sx={{
                        height: 'calc(100vh - 425px)',
                        padding: '0px',
                    }}
                >
                    <Box>
                        {entitySteps[activeStep - 0]?.stepType ===
                        EntityStepTypes.Relations ? (
                            <RelationStep />
                        ) : (
                            <>
                                {entitySteps[activeStep - 0]?.hasProgramStep ? (
                                    <StartStep />
                                ) : null}
                                <AttributeStep onClickMap={onClickMap} />
                            </>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        padding: '15px 0px',
                        paddingRight: '22px',
                    }}
                >
                    <StepButtons
                        handleCloseFields={handleCloseFields}
                        handleAddInParentRelation={handleAddInParentRelation}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}
export default Instance
